import { applyRouteMeta } from '@codium/codium-vue'
import { toNumber } from 'lodash'

export default applyRouteMeta({
  template: 'app',
  requiresAuth: true
}, [
  {
    path: '/settings',
    name: 'settings',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/SettingsList')
  },
  {
    path: '/settings/screen-tags',
    name: 'settings.screen-tags',
    meta: {
      isA: 'admin'
    },
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/ScreenTags'),
  },
  {
    path: '/settings/media-owner-tags',
    name: 'settings.media-owner-tags',
    meta: {
      isA: 'admin'
    },
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/MediaOwnerTags')
  },
  {
    path: '/settings/media-owner-screen-tags',
    name: 'settings.media-owner-screen-tags',
    meta: {
      can: 'read media owner screen tags'
    },
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/MediaOwnerScreenTags')
  },
  {
    path: '/settings/data-transfer',
    name: 'settings.data-transfer',
    meta: {
      can: 'read settings'
    },
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/DataTransfer')
  },
  {
    path: '/settings/report-configuration',
    name: 'settings.report-configuration',
    meta: {
      can: 'read settings'
    },
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/ReportConfiguration')
  },
  {
    path: '/settings/integrations',
    name: 'settings.integrations',
    meta: {
      can: 'read integrations'
    },
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/IntegrationList')
  },
  {
    path: '/settings/integrations/add',
    name: 'settings.integrations.add',
    meta: {
      can: 'write integrations'
    },
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/integrations/IntegrationAdd')
  },
  {
    path: '/settings/integrations/:integrationId',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/integrations/IntegrationSingle'),
    props: ({ params }) => ({ integrationId: toNumber(params.integrationId) }),
    children: [
      {
        path: '/settings/integrations/:integrationId',
        name: 'settings.integrations.single',
        meta: {
          can: 'read integrations'
        },
        component: () => import(/* webpackChunkName: "screens" */ '@/views/settings/integrations/IntegrationSingleDetails')
      },
      {
        path: 'screens',
        name: 'settings.integrations.single.screens',
        meta: {
          can: 'write integrations'
        },
        component: () => import(/* webpackChunkName: "screens" */ '@/views/settings/integrations/IntegrationSingleScreens')
      },
    ]
  },
  {
    path: '/settings/rail-app-release',
    name: 'settings.rail-app-release',
    meta: {
      can: 'read settings'
    },
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/rail-app-release/AppReleaseList.vue')
  },
  {
    path: '/settings/rail-app-release/add',
    name: 'settings.rail-app-release.add',
    meta: {
      can: 'write settings',
      isA: 'admin'
    },
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/rail-app-release/AppReleaseAdd')
  },
  {
    path: '/settings/rail-app-release/:releaseId',
    name: 'settings.rail-app-release.single',
    meta: {
      can: 'read integrations'
    },
    component: () => import(/* webpackChunkName: "screens" */ '@/views/settings/rail-app-release/AppReleaseSingleDetails')
  },
  {
    path: '/settings/energy-providers',
    name: 'settings.energy-providers',
    meta: {
      isA: 'admin'
    },
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/EnergyProviderList')
  },
  {
    path: '/settings/energy-providers/add',
    name: 'settings.energy-providers.add',
    meta: {
      isA: 'admin'
    },
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/energy-providers/EnergyProvidersAdd')
  },
  {
    path: '/settings/energy-providers/:providerId',
    name: 'settings.energy-providers.single',
    props: ({ params }) => ({ providerId: toNumber(params.providerId) }),
    component: () => import(/* webpackChunkName: "settings" */ '@/views/settings/energy-providers/EnergyProviderSingle'),
    meta: {
      isA: 'admin'
    },
  }
])
